'use client';
import React from 'react';
import { MoneyBlocks } from '@benzinga/money';
import { Block } from '@benzinga/content-manager';
import styled from '@benzinga/themetron';
import {
  FusionSection,
  FusionSectionContent,
  fusionSectionContentPadding,
  FusionSectionText,
  FusionSectionTitle,
} from '@benzinga/ui';

interface Props {
  block: Block;
}
const MoneyGroupBlock = ({ block }: Props) => {
  return (
    <StyledSection sectionPadding={false}>
      <FusionSectionContent paddingHorizontal={false} paddingVertical={false} sectionPadding>
        <Header>
          <FusionSectionTitle className="title">
            Secure Your Financial Future <br /> WITH BENZINGA MONEY
          </FusionSectionTitle>
          <FusionSectionText className="subtitle">Compare Rates And Get Expert Insights</FusionSectionText>
        </Header>
      </FusionSectionContent>
      <StyledBlocksSection paddingHorizontal={false} paddingVertical={false}>
        <MoneyBlocks blocks={block ? [block] : undefined} />
      </StyledBlocksSection>
    </StyledSection>
  );
};

const StyledSection = styled(FusionSection)`
  padding-top: 64px;
  padding-bottom: 64px;

  & .article-group-card,
  & .article-headline > div {
    max-width: 100%;
  }
`;

const Header = styled.div`
  & .title {
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 16px;
  }
  & .subtitle {
    text-align: center;
    margin-bottom: 32px;
  }
`;

const StyledBlocksSection = styled(FusionSectionContent)`
  & .grid-wrapper {
    ${fusionSectionContentPadding}
  }
`;

export default MoneyGroupBlock;
